import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { GenericModalService } from '@draeger-academy/presentation/lib/modules/generic-modal';
import { MaintenanceOverlayService } from './maintenance-overlay.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { SubscriptionCollector } from '@draeger-academy/common';
import { ResponsiveState } from '@viablelogic/ngx-responsive';

@Component({
    selector: 'da-maintenance-overlay',
    templateUrl: './maintenance-overlay.component.html',
    styleUrls: ['./maintenance-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MaintenanceOverlayComponent implements OnInit {
    readonly _site: string;
    private _modalId: string;
    private _$isMobile: BehaviorSubject<boolean> = new BehaviorSubject(false);
    @ViewChild('overlay', { static: true }) _overlay;

    @SubscriptionCollector()
    private _subscriptions;

    constructor(
        private _genericModalService: GenericModalService,
        private _maintenanceOverlayService: MaintenanceOverlayService,
        private _responsiveState: ResponsiveState
    ) {}

    public get isMobile$(): Observable<boolean> {
        return this._$isMobile.asObservable();
    }

    ngOnInit(): void {
        this._resizeHandler();
        this._buildOverlay();
    }

    private _buildOverlay() {
        const _overlaySub = this._maintenanceOverlayService.showMaintenanceOverlay$.subscribe((value) => {
            if (value) {
                this._overlayHandler();
                this._maintenanceOverlayService.showMaintenanceOverlay$.next(false);
            }
        });
    }

    private _overlayHandler(): void {
        this._modalId = this._genericModalService.create(this._overlay);
        this._genericModalService.open(this._modalId, null, false, 'da-modal cookie-consent');
    }

    private _resizeHandler(): void {
        this._subscriptions.push(
            this._responsiveState.elemento$.subscribe((val) => {
                this._$isMobile.next(val === 'xs' || val === 'sm' || val === 'md');
            })
        );
    }

    public closeMaintenanceOverlay(): void {
        this._closeOverlay();
    }

    private _closeOverlay(): void {
        this._genericModalService.close(this._modalId);
        this._maintenanceOverlayService.showMaintenanceOverlay$.next(false);
    }
}
